<template>


  <div style="background:#E24D42;width:21px;padding-left: 2px;padding-right:3px;height: 12px;border-radius:3px;color: #2a2a2c; float: right; margin-top: 10px;

                            margin-left: 4px;
                            line-height: 12px;">
    <div style="width: 21px;text-align:center;position:absolute;color: whitesmoke;font-size: 8px;font-weight: bold"> {{text}}</div>
  </div>

</template>
<script>
  export default {
    props: {
      text: {
        type: String,
        default: "0"
      },

    },
    data() {
      return {}
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// icon_text.vue?473703be